import { render, staticRenderFns } from "./EditFanTags.vue?vue&type=template&id=563ee3b6"
import script from "./EditFanTags.vue?vue&type=script&lang=js"
export * from "./EditFanTags.vue?vue&type=script&lang=js"
import style0 from "./EditFanTags.vue?vue&type=style&index=0&id=563ee3b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports